import React from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { Button, Callout, Flex, Text } from 'components/ds'
import styles from './index.module.css'

type Props = {
  to: string
  stacked?: boolean
}

export function RightsDataLookupCallout({ to, stacked }: Props) {
  return (
    <Callout.Root
      color="sky"
      variant="soft"
      size="1"
      mb="2"
      className={styles.callout}
    >
      <div className={clsx(styles.inner, stacked && styles.innerStacked)}>
        <Flex direction="column" gap="1" className={styles.content}>
          <Text size="2" weight="medium" color="sky">
            Search for rights data
          </Text>
          <Text size="1" color="sky">
            Introducing Rights Data Lookup. Search trusted third-party sources
            for rights information that may be available for this track.
          </Text>
        </Flex>
        <Button asChild size="1" color="gray" highContrast>
          <Link to={to}>Search</Link>
        </Button>
      </div>
    </Callout.Root>
  )
}
